// extracted by mini-css-extract-plugin
export default {"dialogContainer":"DialogContainer_dialogContainer__msSon","dialogBackdrop":"DialogContainer_dialogBackdrop__OV40d"};